import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js"; // Ensure Bootstrap JS is loaded

function Slider() {
  return (
    <div className="container mt-5">
      <h2 className="text-center mb-4">📸 Satisfied Members </h2>

      <div className="container">
        <div id="carouselExample" className="carousel slide" data-bs-ride="carousel">
          {/* 🔽 Indicators for Manual Image Selection */}
          <div className="carousel-indicators">
            <button type="button" data-bs-target="#carouselExample" data-bs-slide-to="0" className="active"></button>
            <button type="button" data-bs-target="#carouselExample" data-bs-slide-to="1"></button>
            <button type="button" data-bs-target="#carouselExample" data-bs-slide-to="2"></button>
            <button type="button" data-bs-target="#carouselExample" data-bs-slide-to="3"></button>
            <button type="button" data-bs-target="#carouselExample" data-bs-slide-to="4"></button>
          </div>

          {/* 🔽 Image Slides */}
          <div className="carousel-inner">
            <div className="carousel-item active">
              <img src="/images/slide1.jpg" className="d-block mx-auto img-fluid custom-img" alt="Slide 1" />
            </div>
            <div className="carousel-item">
              <img src="/images/slide2.jpg" className="d-block mx-auto img-fluid custom-img" alt="Slide 2" />
            </div>
            <div className="carousel-item">
              <img src="/images/slide3.jpg" className="d-block mx-auto img-fluid custom-img" alt="Slide 3" />
            </div>
            <div className="carousel-item">
              <img src="/images/slide4.jpg" className="d-block mx-auto img-fluid custom-img" alt="Slide 4" />
            </div>
            <div className="carousel-item">
              <img src="/images/slide5.jpg" className="d-block mx-auto img-fluid custom-img" alt="Slide 5" />
            </div>
          </div>

          {/* 🔽 Previous & Next Buttons with Better Visibility */}
          <button className="carousel-control-prev" type="button" data-bs-target="#carouselExample" data-bs-slide="prev">
            <span className="carousel-control-prev-icon custom-arrow" aria-hidden="true"></span>
          </button>
          <button className="carousel-control-next" type="button" data-bs-target="#carouselExample" data-bs-slide="next">
            <span className="carousel-control-next-icon custom-arrow" aria-hidden="true"></span>
          </button>
        </div>
      </div>

      <p className="text-center mt-3"> For Big Earning Join My Telegram Channel! 🎯</p>

      {/* 🔽 Custom Styles */}
      <style>
        {`
          .custom-img {
            max-height: 350px;  /* Adjust height as needed */
            width: auto;
            object-fit: contain; /* Keeps aspect ratio */
          }

          @media (max-width: 768px) {
            .custom-img {
              max-height: 250px; /* Smaller height on mobile */
            }
          }

          .carousel-indicators button {
            background-color: #007bff; /* Blue indicators */
            border-radius: 50%;
            width: 10px;
            height: 10px;
          }

          .carousel-indicators .active {
            background-color: #ff4500; /* Orange for active indicator */
          }

          /* 🔽 Styling for Previous & Next Buttons */
          .carousel-control-prev,
          .carousel-control-next {
            width: 5%;
          }

          .carousel-control-prev-icon,
          .carousel-control-next-icon {
            background-color: rgba(0, 0, 0, 0.6); /* Dark background for visibility */
            border-radius: 50%; 
            padding: 15px; /* Increase icon size */
          }

          .carousel-control-prev-icon:hover,
          .carousel-control-next-icon:hover {
            background-color: rgba(255, 69, 0, 0.9); /* Orange hover effect */
          }
        `}
      </style>
    </div>
  );
}

export default Slider;
